module.exports = __webpack_public_path__ + "01_mustache_brown.336f391f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer3/01_mustache_brown.png
// module id = GcEJ
// module chunks = 0